import { InterfaceLanguage } from "@callcenter/shared-types"

export const INTERFACE_LANGUAGES = [InterfaceLanguage.en, InterfaceLanguage.es]
